import React from 'react'
import { HtmlContent } from 'utils'

import styles from './styles/information_component.module.scss'
import classNames from 'classnames'

const InformationComponent = ({title, description, type}) => {

  const sectionClassNames = classNames({
    [styles.information_component]: true,
    [styles[`information_component--${type}`]]: true
  })

  const textClassNames = classNames({
    [styles.information_component__text]: true,
    [styles[`information_component__text--${type}`]]: true
  })
  
  return (
    <section className={sectionClassNames}>
      <div className={textClassNames}>
        <h2 className={styles.information_component__title}>{title}</h2>
        <HtmlContent content={description} className={styles.information_component__description} />
      </div>
    </section>
  )
}

export default InformationComponent